<template>
  <div>
    Processing authentication data...
  </div>
</template>

<script>
  export default {
    name: 'CognitoOAuthAuthorizeCallback',
    created() {
      this.$store.commit('hideHeaderAndFooter')
    },
    mounted() {
      const hash = location.hash + '&'
      const state = decodeURIComponent(hash.substr(hash.indexOf('state=')).split('&')[0].split('=')[1])
      const idToken = hash.substr(hash.indexOf('id_token=')).split('&')[0].split('=')[1]
      const accessToken = hash.substr(hash.indexOf('access_token=')).split('&')[0].split('=')[1]
      const tokenType = hash.substr(hash.indexOf('token_type=')).split('&')[0].split('=')[1]
      const expiresIn = hash.substr(hash.indexOf('expires_in=')).split('&')[0].split('=')[1]
      const error = hash.substr(hash.indexOf('error=')).split('&')[0].split('=')[1]

      // post a message to the window that opened this popup window (see Login.vue)
      window.opener.postMessage(
        { messageId: 'pfxFederatedIdToken', idToken, accessToken, tokenType, expiresIn, error, hash },
        state
      )
    }
  }
</script>

<style lang="scss" scoped>
  div {
    text-align: center;
    padding: 100px 12px;
    font-family: 'Encode Sans', sans-serif;
    font-size: 24px;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/components/CognitoOAuthAuthorizeCallback.vue